<div class="wrapper">
  <div class="top-row">
    <div class="heading text-type-5">
      {{ data?.bid_item?.item }}
    </div>
    @if (data?.updated_at) {
      <div class="time-ago text-type-14">
        {{ data?.updated_at | dateFormat : 'ago' }} ago
      </div>
    }
  </div>
  <div class="test-name text-type-14">{{ data?.material_test?.name }}</div>
  <div class="status-label flex justify-start items-center gap-[10px]">
    @if (data?.status === 'passed' || data?.status === 'cancelled') {
      <mat-icon
        [class.cancelled]="data?.status === 'cancelled'"
        [class.passed]="data?.status === 'passed'"
        class="status-icon"
        >
        {{ data?.status === 'passed' ? 'done' : (data?.status === 'cancelled' ? 'closed' : '') }}
      </mat-icon>
    }
    {{ data?.statusInfo?.label }}
  </div>
</div>
